import Currency from "../../../../../../components/currency/currency";
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../components/fonts/font-props";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import RefundCalculatorStore from "../../../stores/refund-calculator-store";
import RefundCalculatorGridLayout from "./refund-calculator-grid-layout/refund-calculator-grid-layout";
import "./refund-calculator.scss";
import { observer } from "mobx-react";

interface IRefundCalculatorProps {
    calculatorStore: RefundCalculatorStore
}

const RefundCalculator: React.FC<IRefundCalculatorProps> = observer(({calculatorStore}) => {

    const amountPaid = calculatorStore.itemsPaidAmountInStoreCurrency;
    const showTax = calculatorStore.showTax;

    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';

    return (
        <>
            { !!amountPaid &&
                <div className="refund-calculator-amount-title">
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('AMOUNT_PAID_CALCULATOR_TITLE', pageScope)}</FontBody1>
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                        <Currency amount={amountPaid.amount} currencyCode={amountPaid.currency_code} />
                    </FontBody1>
                </div>  
            }
            <hr/>
            <RefundCalculatorGridLayout showTax={showTax} calculatorStore={calculatorStore} />
        </>

    )
})

export default RefundCalculator;